import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdEdit} from "react-icons/md";
import CourierPartnerService from "../../Services/CourierPartnerService";
import { useHistory } from "react-router-dom";
import CheckAccess from "../../Function/CheckAccess";
import { toast } from "react-toastify";

export const CourierPartnerList = () => {
  const [data,setData] = useState([])
  const [loader,setLoader] = useState(false)
  const [statusModal,setStatusModal] = useState({modal:false,item:null})
  const history = useHistory()

  const handleStatusChange = async () => {
    setLoader(true);
    const params = {
      id : statusModal.item._id,
      status : statusModal.item.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    }
    await CourierPartnerService.editCourierPartner(params).then((res) => {
      console.log(res,'res')
      if (res.status) {
        setStatusModal({modal:false,item:null})
        getDetail();
      }else{
        setLoader(false);
        toast.error(res.message)
      }
    }).catch((err)=> {
      setLoader(false);
      toast.error(err.message)
      console.log(err,'err')
    })
  };

  const getDetail = async () => {
    setLoader(true);
    await CourierPartnerService.getCourierPartnerList().then((res) => {
      setLoader(false);
      if (res.status) {
        setData(res.data);
      }else{
        toast.error(res.message)
      }
    }).catch((err)=> {
      setLoader(false);
      toast.error(err.message)
      console.log(err,'err')
    })
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
            <Button
              type="button"
              className="btn btn-primary"
              onClick={()=> history.push("/add-courier-partner", { data })}
            >
              Add Courier Partner
            </Button>
          </div>
          <div className="table-responsive">
            <table className="table table-centered table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th>S No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Address</th>
                  <th>City, State, Country</th>
                  <th>Postal Code</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loader
                ? <tr><td colSpan={8} className="text-center"><Spinner animation="border" /></td></tr>
                : (data && data.length > 0)
                ? data?.map((item, key) => (
                    <tr key={key}>
                      <td className="text-body fw-bold">{(key + 1)}</td>
                      <td className="text-body">{item?.full_name}</td>
                      <td className="text-body">{item?.email}</td>
                      <td className="text-body">{item?.address || "-"}</td>
                      <td className="text-body">{(item?.city && item?.state && item?.country) ? `${item.city}, ${item.state}, ${item.country}` : "-"}</td>
                      <td className="text-body">{item?.postal_code || "-"}</td>
                      <td className="text-body">
                          <span
                              className={
                                "badge rounded-pill font-size-12 pointer" +
                                (item.status === "ACTIVE"
                                  ? " bg-success"
                                  : " bg-soft-danger")
                              }
                              onClick={() => setStatusModal({modal:true,item:item})}
                            >
                              {item.status}
                            </span>
                      </td>
                        {CheckAccess(225, "edit") && (                            
                          <td>
                            <MdEdit
                              className="pointer"
                              onClick={()=> 
                              history.push(
                                "/edit-courier-partner?id=" + item._id,
                                item,
                              )
                              }
                              style={{ fontSize: "22px", color: "rgb(3, 35, 254)" }}
                            />
                          </td>
                         )}
                    </tr>
                  ))
                : <tr><td colSpan={8} className="text-center">Data Not Available</td></tr>
                }
              </tbody>
            </table>
          </div>

          {/* {/ Delete Modal /} */}
          {statusModal.modal && 
            <Modal
              show={statusModal.modal}
              onHide={() => setStatusModal({modal:false,item:null})}
              animation={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Change Status</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h6>Are you sure want to set status to {`${statusModal.item.status==="ACTIVE" ? 'Inactive' : 'active'}`}</h6>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={() => setStatusModal({modal:false,item:null})}>
                  Close
                </Button>
                <Button variant="success" onClick={handleStatusChange}>
                  {(loader && <Spinner animation="grow" size="sm" />) || "Confirm"}
                </Button>
              </Modal.Footer>
            </Modal>
          }
        </div>
      </div>
    </div>
  );
};


export default CourierPartnerList